const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

// Definir la base del API localmente
export async function getSeccionesAcademicas() {
  try {
    console.log('[secciones_academicas.js] Llamando a:', `${API_BASE}/catalogos/secciones-academicas/`);
    const res = await fetch(`${API_BASE}/catalogos/secciones-academicas/`, {
      headers: getAuthHeaders()
    });
    console.log('[secciones_academicas.js] Status:', res.status);
    if (!res.ok) {
      console.error('[secciones_academicas.js] Error en respuesta:', res.status, res.statusText);
      return [];
    }

    const data = await res.json();
    console.log('[secciones_academicas.js] Datos recibidos:', data);

    if (Array.isArray(data) && data.length > 0) {
      const mapped = data.map(s => ({
        id: s.id_seccion,
        id_seccion: s.id_seccion,
        nombre: s.nombre_seccion,
        nombre_seccion: s.nombre_seccion,
        codigo: s.codigo_seccion,
        activo: s.activo,
      }));
      console.log('[secciones_academicas.js] Secciones mapeadas:', mapped);
      return mapped;
    }
    console.warn('[secciones_academicas.js] No hay secciones en la respuesta');
    return [];
  } catch (err) {
    console.error('[secciones_academicas.js] Error al cargar secciones:', err);
    return [];
  }
}

// Alias para usar como getSecciones (más corto)
export const getSecciones = getSeccionesAcademicas;
